<template>
  <div>
    <div class="module-result-content">
      <div class="result-content">
        <el-table
            :data="tableData.list"
            style="width: 100%"
            height='calc(100vh - 120px)'>
          <el-table-column
              prop="startTime"
              label="日期"
              width="200"
          >
            <template scope="scope">
              <div>{{new Date(scope.row.createTime).Format('yyyy-MM-dd hh:mm:ss')}}</div>
            </template>
          </el-table-column>
          <el-table-column
              prop="name"
              label="文件名称"
              min-width="300"
              :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
              prop="fileSize"
              label="大小"
              width="120"
              align="center"
          >
            <template scope="scope">
              <div v-if="parseInt(scope.row.fileSize/1000000)">{{scope.row.fileSize | numberFilter}}</div>
              <div v-else>
                <div v-if="parseInt(scope.row.fileSize/1000)">
                  {{parseFloat(scope.row.fileSize / 1000).toFixed(2)}}KB
                </div>
                <div v-else>{{scope.row.fileSize}}B</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="runTimes"
              label="状态"
              width="120"
              align="center"
          >
            <template scope="scope">
              <div v-if="scope.row.runTimes === 1">100%</div>
              <div v-else-if="scope.row.runTimes ===0">0%</div>
            </template>
          </el-table-column>
          <el-table-column
              fixed="right"
              label="操作"
              width="130"
              align="center"
          >
            <template slot-scope="scope">
              <el-button
                  type="text"
                  v-if="scope.row.runTimes === 1"
              >
                <a  style="text-decoration: none;color: #409eff" :href="scope.row.url" target="_blank">下载</a>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-pagination
        style="position: absolute;bottom: 5px;right: 20px"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableData.total">
    </el-pagination>
  </div>

</template>

<script>

export default {
name: "downLoad",
  components: {},
  data(){
  return{
    tableData:{
      list:[],
      total:0
    },
    currentPage:1,
    pageSize:20
  }
  },
  filters:{
    numberFilter(value){
      console.log(value)
      let realVal=0
      realVal=value / 1000000
      console.log(realVal)
      realVal = parseFloat(realVal).toFixed(2)
      return realVal
    }
  },
  mounted() {
  this.getFileDown()
  },
  methods:{
  //获取下载的列表
    getFileDown(){
      this.$http.get('api/task/order-download?num='+this.pageSize+'&page='+this.currentPage).then(res=>{
        console.log(res.data)
        this.tableData.list=res.data.data.content
        this.tableData.total=res.data.data.totalElements
      })
    },
    downLoad(){},
    handleSizeChange(value){
      this.pageSize=value
      this.getFileDown()
    },
    handleCurrentChange(value){
      this.currentPage=value
      this.getFileDown()
    }
  }
}
</script>

<style  lang="less">
.module-result-content {
  flex: 1;
  display: flex;
  flex-direction: column;

  .result-content {
    flex: 1;
    position: relative;
    .el-table {
      width: 100%;
      position: absolute;
      overflow: hidden;
    }
  }
  .el-table__row{
    height: 64px;
    line-height: 64px;
  }
}
</style>